exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{\r\n    background-color: lightcyan;\r\n    width: 100%;\r\n    height: auto;\r\n    margin: 2em auto;\r\n    font-size: 25px;\r\n    line-height: 30px;\r\n    text-align: justify;\r\n    \r\n}\r\n\r\n.width40left{\r\n    width: 40%;\r\n    margin-left: 4%;\r\n    margin-right: 4%;\r\n    /* float: left; */\r\n    display: inline-block;\r\n}\r\n\r\n.width40right{\r\n    width: 40%;\r\n    margin-left: 4%;\r\n    margin-right: 4%;\r\n    /* float: right; */\r\n    display: inline-block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/home/home.component.css
// module id = ../../../../../src/app/components/home/home.component.css
// module chunks = main